import React from 'react';
import { Select } from 'antd';

const StatusDropdown = ({ value, onChange, options, disabled }) => {
  // Convert options array to format required by Ant Design Select
  const statusOptions = options.map(option => ({
    value: option,
    label: option.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())
  }));

  return (
    <Select
      value={value}
      onChange={onChange}
      disabled={disabled}
      style={{ width: '100%' }}
      options={statusOptions}
      className={`status-${value} ${disabled ? 'bg-gray-100' : ''}`}
    />
  );
};

export default StatusDropdown; 